import './Greenbutton.css';

function GreenButton({ disabled = false, text, onClick, type = 'button' }) {
  return (
    <button type={type} className="green-button" disabled={disabled} onClick={onClick}>
      {text}
    </button>
  );
}

export default GreenButton;
